 /**
 * Texts for Notifications page
 */
export const notificationsPageText = {
    title: 'Neueste In-App-Benachrichtigungen',
    titleMeta: 'Zeigt aktuelle In-App-Benachrichtigungen von CamAPS FX',
    descriptionMeta: 'Hier finden Sie den Text der letzten In-App-Benachrichtigungen zu App-Updates, Sicherheitshinweisen und Benutzerhandbuch-Updates',
    keywords: 'Benachrichtigungen' ,
    localeMeta: 'de_de',

    heading: 'Neueste In-App-Benachrichtigungen',
    subheading: '',

    header_133:'',
    body_133:'',

    header_132:'Android-App-Update (YpsoPump nur) 28/10/2026',
    body_132:'Lieber CamAPS FX-Nutzer, eine neue Version der Anwendung 1.4(195) wird in den nächsten Tagen verfügbar sein. Bitte wählen Sie Ihre bevorzugte Update-Zeit, indem Sie das automatische Update für CamAPS FX im Google Play Store deaktivieren. Wenn Sie Fragen haben, kontaktieren Sie bitte den Kundendienst von mylife-Diabetescare.',

    header_131:'',
    body_131:'',

    header_130:'Update erforderlich (nur YpsoPump) 20/10/2026',
    body_130:'Update erforderlich! Diese Version von CamAPS FX kann häufiger abstürzen und neu starten. Bitte aktualisieren Sie die App JETZT über den Google Play Store auf die neueste Version. App-Version 1.4(190) wird am 20/11/2026 eingestellt. Nach diesem Datum ist „Auto mode“ nicht mehr verfügbar, bis die App aktualisiert wurde. Die Insulinabgabe über Ihre Pumpe wird fortgesetzt.',

    header_129:'',
    body_129:'',

    header_128:'Aktualisierung des Benutzerhandbuchs (nur YpsoPump) 15/10/2026',
    body_128:'Eine aktualisierte Version des Benutzerhandbuchs ist jetzt verfügbar. Sie können darauf über das Hauptmenü von CamAPS FX zugreifen, indem Sie Hilfe auswählen, nachdem Sie auf die neueste App-Version aktualisiert haben.',

    header_127:'iOS-App-Update (YpsoPump only) 08/10/2026',
    body_127:'Lieber CamAPS FX-Nutzer, eine NEUE VERSION der Anwendung 1.4(196) wird in den nächsten Tagen verfügbar sein. DEAKTIVIEREN Sie die AUTOMATISCHEN UPDATE von CamAPS FX im App Store, um Ihre bevorzugte Update-Zeit auszuwählen. Bei Fragen wenden Sie sich bitte an den mylife-Diabetescare-Kundendienst.',

    header_126:'Android-App-Update (YpsoPump nur) 02/10/2026',
    body_126:'Nur für LU & AT - Lieber CamAPS FX-Nutzer, eine neue Version der Anwendung 1.4(194) wird in den nächsten Tagen verfügbar sein. Bitte wählen Sie Ihre bevorzugte Update-Zeit, indem Sie das automatische Update für CamAPS FX im Google Play Store deaktivieren. Wenn Sie Fragen haben, kontaktieren Sie bitte den Kundendienst von mylife-Diabetescare.',

    header_125:'Android-App-Update (YpsoPump nur) 30/09/2026',
    body_125:'Nur für DE & BE - Lieber CamAPS FX-Nutzer, eine neue Version der Anwendung 1.4(194) wird in den nächsten Tagen verfügbar sein. Bitte wählen Sie Ihre bevorzugte Update-Zeit, indem Sie das automatische Update für CamAPS FX im Google Play Store deaktivieren. Wenn Sie Fragen haben, kontaktieren Sie bitte den Kundendienst von mylife-Diabetescare.',

    header_124:'',
    body_124:'',

    header_123:'',
    body_123:'',

    header_122:'iOS-App-Update (YpsoPump only) 28/09/2026',
    body_122:'Lieber CamAPS FX-Nutzer, eine NEUE VERSION der Anwendung 1.4(196) wird in den nächsten Tagen verfügbar sein. DEAKTIVIEREN Sie die AUTOMATISCHEN UPDATE von CamAPS FX im App Store, um Ihre bevorzugte Update-Zeit auszuwählen. Bei Fragen wenden Sie sich bitte an den mylife-Diabetescare-Kundendienst.',

    header_121:'Apple iOS 27 Veröffentlichung 11/09/2026',
    body_121:'Apple wird bald iOS 27 veröffentlichen. Um die unterbrechungsfreie Nutzung der CamAPS FX App sicherzustellen, prüfen Sie bitte VOR der Aktualisierung Ihres iPhones auf iOS 27 auf der Website des Sensorherstellers die Kompatibilität Ihres Smartphones und Betriebssystems. Automatische Updates können in den Einstellungen Ihres Telefons standardmäßig EINGESCHALTET sein. Bitte erwägen Sie, diese AUSZUSCHALTEN.',

    header_120:'',
    body_120:'',

    header_119:'Aktualisierung des Benutzerhandbuchs (nur YpsoPump) 10/09/2026',
    body_119:'Eine aktualisierte Version des Benutzerhandbuchs ist jetzt verfügbar. Sie können darauf über das Hauptmenü von CamAPS FX zugreifen, indem Sie Hilfe auswählen, nachdem Sie auf die neueste App-Version aktualisiert haben.',

    header_118:'Android-App-Update (YpsoPump nur) 07/09/2026',
    body_118:'Nur für LU, AT & CH - Lieber CamAPS FX-Nutzer, eine neue Version der Anwendung 1.4(193) wird in den nächsten Tagen verfügbar sein. Bitte wählen Sie Ihre bevorzugte Update-Zeit, indem Sie das automatische Update für CamAPS FX im Google Play Store deaktivieren. Wenn Sie Fragen haben, kontaktieren Sie bitte den Kundendienst von mylife-Diabetescare.',

    header_117:'',
    body_117:'',

    header_116:'Android-App-Update (YpsoPump nur) 31/08/2026',
    body_116:'Nur für DE & BE - Lieber CamAPS FX-Nutzer, eine neue Version der Anwendung 1.4(193) wird in den nächsten Tagen verfügbar sein. Bitte wählen Sie Ihre bevorzugte Update-Zeit, indem Sie das automatische Update für CamAPS FX im Google Play Store deaktivieren. Wenn Sie Fragen haben, kontaktieren Sie bitte den Kundendienst von mylife-Diabetescare.',

    header_115:'',
    body_115:'',

    header_114:'',
    body_114:'',

    header_113:'',
    body_113:'',

    header_112:'',
    body_112:'',

    header_111:'Deaktivierung von Android-Versionen unter 1.4(192) (Ypsopump only) 03/08/2026',
    body_111:'Lieber CamAPS FX-Nutzer, aus Gründen der Cybersicherheit werden Versionen UNTER 1.4(192) am 31/08/2026 EINGESTELLT. Bitte stellen Sie sicher, dass Ihre App vor diesem Datum auf Version 1.4(192) AKTUALISIERT ist. Wenn Sie Fragen haben, wenden Sie sich bitte an den mylife-Diabetescare-Kundendienst.',

    header_110:'',
    body_110:'',
    body_110_link_text:'',
    body_110_end: '',
    body_110_link:'',

    header_109:'Android OS 17 Veröffentlichung 24/06/2026',
    body_109:'Android wird in Kürze OS 17 veröffentlichen. Um die unterbrechungsfreie Nutzung der CamAPS FX App sicherzustellen, prüfen Sie bitte VOR der Aktualisierung auf OS 17 auf der Website des Sensorherstellers die Kompatibilität Ihres Smartphones und Betriebssystems. Automatische Updates können in den Einstellungen Ihres Telefons standardmäßig EINGESCHALTET sein. Bitte schalten Sie diese AUS.',

    header_108:'Dexcom G7 ist verfügbar (nur Ypsopump) 23/06/2026',
    body_108:'Die Integration des Dexcom G7 CGM-Systems ist jetzt verfügbar! Nutzerinnen und Nutzer, die vom Dexcom G6 wechseln, finden auf unserer Website eine Anleitung zum Wechsel, Hinweise zur Fehlerbehebung sowie eine Übersicht der kompatiblen CGM-Systeme: www.mylife-diabetescare.com.',

    header_107:'',
    body_107:'',

    header_106:'Aktualisierung des Benutzerhandbuchs (nur YpsoPump) 22/06/2026',
    body_106:'Eine aktualisierte Version des Benutzerhandbuchs ist jetzt verfügbar. Sie können darauf über das Hauptmenü von CamAPS FX zugreifen, indem Sie Hilfe auswählen.',

    header_105:'Dexcom G7 ist verfügbar (nur YpsoPump; nur Dexcom G6) 19/06/2026',
    body_105:'Nur CH - Erneuter Hinweis: die Integration des Dexcom G7 CGM-Systems ist verfügbar! Nutzerinnen und Nutzer, die vom Dexcom G6 wechseln, finden eine konkrete Anleitung zum Vorgehen auf unserer Website: www.mylife-diabetescare.com.',

    header_104:'',
    body_104:'',

    header_103:'Android-App-Update (YpsoPump nur) 12/06/2026',
    body_103:'Nur für AT - Lieber mylife CamAPS FX-Nutzer, eine neue Version der Anwendung 1.4(192) wird in den nächsten Tagen verfügbar sein. Bitte wählen Sie Ihre bevorzugte Update-Zeit, indem Sie das automatische Update für CamAPS FX im Google Play Store deaktivieren. Wenn Sie Fragen haben, kontaktieren Sie bitte den Kundendienst von mylife-Diabetescare.',

    header_102:'',
    body_102:'',

    header_101:'Dexcom G7 ist verfügbar (nur YpsoPump; nur Android) 09/06/2026',
    body_101:'Nur für CH - Die Integration des Dexcom G7 CGM-Systems ist ab jetzt verfügbar! Nutzerinnen und Nutzer, die vom Dexcom G6 wechseln, finden weitere Informationen sowie eine Übersicht kompatibler CGM-Systeme auf unserer Website: www.mylife-diabetescare.com.',

    header_100:'Android-App-Update (nur YpsoPump) 05/06/2026',
    body_100:'Nur für CH, DE & BE - Sehr geehrte/r CamAPS FX Nutzer/in, eine neue Version von CamAPS FX, 1.4(192), wird in den nächsten Tagen verfügbar sein. Um selbst zu bestimmen, wann Sie aktualisieren, deaktivieren Sie bitte die AUTOMATISCHEN UPDATES im Google Play Store. Nutzer mit Android-Versionen UNTER OS 13 können CamAPS FX NICHT auf diese Version AKTUALISIEREN. Eine aktualisierte Version des Benutzerhandbuchs ist jetzt verfügbar. Bei Fragen wenden Sie sich bitte an den mylife-Diabetescare Kundenservice.',

    header_99:'Dexcom G7 ist verfügbar (nur YpsoPump; nur iOS) 02/06/2026',
    body_99:'Nur für CH - Die Integration des Dexcom G7 CGM-Systems ist ab jetzt verfügbar! Nutzerinnen und Nutzer, die vom Dexcom G6 wechseln, finden weitere Informationen sowie eine Übersicht kompatibler CGM-Systeme auf unserer Website: www.mylife-diabetescare.com.',

    header_98:'Einstellung alter Betriebssysteme 22/05/2026',
    body_98:'Während wir unser nächstes App-Update vorbereiten, beachten Sie bitte, dass CamAPS FX NUR auf sensor-kompatiblen Smartphones unterstützt wird, die mit Android OS 13 oder höher bzw. Apple iOS 18 oder höher laufen. Nach der Veröffentlichung des Updates können Nutzer mit Smartphones, die UNTER Android OS 13 oder iOS 18 laufen, CamAPS FX NICHT mehr AKTUALISIEREN oder NEU INSTALLIEREN.',

    header_97:'iOS-App-Update 22/05/2026',
    body_97:'Sehr geehrte/r CamAPS FX Nutzer/in, eine neue Version von CamAPS FX, 1.4(195), wird in den nächsten Tagen verfügbar sein. Um selbst zu bestimmen, wann Sie aktualisieren, deaktivieren Sie bitte die AUTOMATISCHEN UPDATES im App Store. Nutzer mit iOS-Versionen UNTER Apple iOS 18 können CamAPS FX NICHT auf diese Version AKTUALISIEREN. Eine aktualisierte Version des Benutzerhandbuchs ist jetzt verfügbar. Bei Fragen wenden Sie sich bitte an den mylife-Diabetescare Kundenservice.',

    header_96:'Einstellung alter Betriebssysteme 11/05/2026',
    body_96:'Nur für CH - Während wir unser nächstes App-Update vorbereiten, beachten Sie bitte, dass CamAPS FX NUR auf sensor-kompatiblen Smartphones unterstützt wird, die mit Android OS 13 oder höher bzw. Apple iOS 18 oder höher laufen. Nach der Veröffentlichung des Updates können Nutzer mit Smartphones, die UNTER Android OS 13 oder iOS 18 laufen, CamAPS FX NICHT mehr AKTUALISIEREN oder NEU INSTALLIEREN. Bei Fragen wenden Sie sich bitte an den mylife-Diabetescare Kundenservice.',

    header_95:'',
    body_95:'',

    header_94:'Dexcom G7-Update (nur Ypsopump) 28/04/2026',
    body_94:'Nur für CH - Wir nähern uns der Dexcom G7 Kompatibilität mit Ihrer CamAPS FX App! Die Integration wird in der Schweiz voraussichtlich zwischen Mitte und Ende Mai 2026 verfügbar sein. Weitere Updates folgen in Kürze.',

    header_93:'Deaktivierung von iOS-Versionen unter 1.4(193) (nur Ypsopump) 22.04.2026',
    body_93:'Sehr geehrte CamAPS-FX-Nutzerin, sehr geehrter CamAPS-FX-Nutzer, aus Gründen der Cybersicherheit werden VERSIONEN UNTER 1.4(193) am 30. April DEAKTIVIERT. Bitte stellen Sie sicher, dass Ihre App vor diesem Datum auf Version 1.4(193) AKTUALISIERT ist. Bei Fragen wenden Sie sich bitte an den mylife-Diabetescare Kundenservice.',

    header_92:'Einstellung alter Betriebssysteme 21/04/2026',
    body_92:'Aus Gründen der Cybersicherheit wird mylife CamAPS FX ab dem 30. Juni 2026 NUR noch auf sensor-kompatiblen Smartphones unterstützt, die die folgenden Betriebssysteme verwenden: Android OS 13 oder höher sowie Apple iOS 18 oder höher. Nutzer von Betriebssystemen UNTER Android OS 13 oder Apple iOS 18 können mylife CamAPS FX nach diesem Datum NICHT mehr AKTUALISIEREN oder NEU INSTALLIEREN.',

    header_91:'',
    body_91:'',
    body_91_link_text:'',
    body_91_end: '',
    body_91_link:'',

    header_90:'Dexcom G7-Update (nur Ypsopump) 23/04/2026',
    body_90:'Nur für AT - Wir kommen der Kompatibilität des Dexcom G7 CGM-Systems mit CamAPS FX näher! Die Integration wird im Sommer 2026 verfügbar sein. Weitere Updates folgen in Kürze.',

    header_89:'Dexcom G7-Update (nur Ypsopump) 07/04/2026',
    body_89:'Nur für DE - Wir kommen der Kompatibilität des Dexcom G7 CGM-Systems mit CamAPS FX näher! Die Integration wird im Sommer 2026 verfügbar sein. Weitere Updates folgen in Kürze.',

    header_88:'',
    body_88:'',

    header_87:'Deaktivierung von iOS-Versionen unter 1.4(193) (nur Ypsopump) 16.03.2026',
    body_87:'Sehr geehrte CamAPS-FX-Nutzerin, sehr geehrter CamAPS-FX-Nutzer, aus Gründen der Cybersicherheit werden VERSIONEN UNTER 1.4(193) am 31. März DEAKTIVIERT. Bitte stellen Sie sicher, dass Ihre App vor diesem Datum auf Version 1.4(193) AKTUALISIERT ist. Bei Fragen wenden Sie sich bitte an den mylife-Diabetescare Kundenservice.',

    header_86:'',
    body_86:'',
    body_86_link_text:'',
    body_86_end: '',
    body_86_link:'',

    header_85:'',
    body_85:'',

    header_84:'',
    body_84:'',

    header_83:'',
    body_83:'',

    header_82:'Android-App-Update (nur Ypsopump) 02.02.2026',
    body_82:'Sehr geehrte CamAPS-FX-Nutzerin, sehr geehrter CamAPS-FX-Nutzer, in den nächsten Tagen wird eine NEUE VERSION der Anwendung verfügbar sein – 1.4(190). DEAKTIVIEREN Sie die AUTOMATISCHEN UPDATES von CamAPS FX im Google Play Store, um Ihren bevorzugten Aktualisierungszeitpunkt selbst auszuwählen. Aus Gründen der Cybersicherheit werden VERSIONEN UNTERHALB von 1.4(190) am 31. März EINGESTELLT. Bei Fragen wenden Sie sich bitte an den mylife-Diabetescare Kundenservice.',

    header_81:'',
    body_81:'',

    header_80:'',
    body_80:'',

    header_79:'',
    body_79:'',

    header_78:'',
    body_78:'',

    header_77:'Nachricht von mylife-Diabetescare (nur YpsoPump) 17.12.2025',
    body_77:'Nur für DE & AT - Wichtig! Bitte nutzen Sie ab heute die Nachfülloption der mylife YpsoPump Reservoire. Dies ist ein wesentlicher Beitrag für Ihre Therapiekontinuität. Vielen Dank.',

    header_76:'',
    body_76:'',

    header_75:'',
    body_75:'',

    header_74:'Nachricht von mylife-Diabetescare (nur YpsoPump) 09.12.2025',
    body_74:'Sie können Ihr mylife YpsoPump Reservoir einmal nachfüllen innerhalb von 7 Tagen nach der ersten Befüllung. Erfahren Sie mehr auf der Reservoir-Seite der Website von mylife-diabetescare.',

    header_73:'Wichtige Sicherheitsinformationen zu Ihrem FreeStyle Libre 3 System-Sensor (Nur für CH) 25/11/2025',
    body_73:'Abbott hat festgestellt, dass einige FreeStyle Libre 3 und FreeStyle Libre 3 Plus Sensoren möglicherweise fälschlich niedrige Glukosewerte anzeigen. Besuchen Sie',
    body_73_link_text:'www.FreeStyleCheck.com',
    body_73_end: ', um zu prüfen, ob Ihr aktueller oder unbenutzter Sensor potenziell betroffen ist. Wenn Ihre Sensorwerte nicht mit Ihren Symptomen oder Erwartungen übereinstimmen, schalten Sie den Auto-Modus aus und verwenden Sie ein Blutzuckermessgerät, um Therapieentscheidungen zu treffen. Wenn Sie Fragen haben oder Probleme mit Ihrem FreeStyle Libre 3 System-Sensor melden müssen, wenden Sie sich an den Abbott-Kundendienst unter 08 00 804 404. Die Seriennummer Ihres aktuellen Sensors finden Sie im App-Menü im Abschnitt „Sensor“.',
    body_73_link:'https://www.FreeStyleCheck.com',

    header_72:'Wichtige Sicherheitsinformationen zu Ihrem FreeStyle Libre 3 System-Sensor (Nur für LU) 25/11/2025',
    body_72:'Abbott hat festgestellt, dass einige FreeStyle Libre 3 und FreeStyle Libre 3 Plus Sensoren möglicherweise fälschlich niedrige Glukosewerte anzeigen. Besuchen Sie',
    body_72_link_text:'www.FreeStyleCheck.com',
    body_72_end: ', um zu prüfen, ob Ihr aktueller oder unbenutzter Sensor potenziell betroffen ist. Wenn Ihre Sensorwerte nicht mit Ihren Symptomen oder Erwartungen übereinstimmen, schalten Sie den Auto-Modus aus und verwenden Sie ein Blutzuckermessgerät, um Therapieentscheidungen zu treffen. Wenn Sie Fragen haben oder Probleme mit Ihrem FreeStyle Libre 3 System-Sensor melden müssen, wenden Sie sich an den Abbott-Kundendienst unter 8002 54 87. Die Seriennummer Ihres aktuellen Sensors finden Sie im App-Menü im Abschnitt „Sensor“.',
    body_72_link:'https://www.FreeStyleCheck.com',

    header_71:'Wichtige Sicherheitsinformationen zu Ihrem FreeStyle Libre 3 System-Sensor (Nur für DE) 25/11/2025',
    body_71:'Abbott hat festgestellt, dass einige FreeStyle Libre 3 und FreeStyle Libre 3 Plus Sensoren möglicherweise fälschlich niedrige Glukosewerte anzeigen. Besuchen Sie',
    body_71_link_text:'www.FreeStyleCheck.com',
    body_71_end: ', um zu prüfen, ob Ihr aktueller oder unbenutzter Sensor potenziell betroffen ist. Wenn Ihre Sensorwerte nicht mit Ihren Symptomen oder Erwartungen übereinstimmen, schalten Sie den Auto-Modus aus und verwenden Sie ein Blutzuckermessgerät, um Therapieentscheidungen zu treffen. Wenn Sie Fragen haben oder Probleme mit Ihrem FreeStyle Libre 3 System-Sensor melden müssen, wenden Sie sich an den Abbott-Kundendienst unter 08 00 519 95 19. Die Seriennummer Ihres aktuellen Sensors finden Sie im App-Menü im Abschnitt „Sensor“.',
    body_71_link:'https://www.FreeStyleCheck.com',

    header_70:'Wichtige Sicherheitsinformationen zu Ihrem FreeStyle Libre 3 System-Sensor (Nur für AT) 25/11/2025',
    body_70:'Abbott hat festgestellt, dass einige FreeStyle Libre 3 und FreeStyle Libre 3 Plus Sensoren möglicherweise fälschlich niedrige Glukosewerte anzeigen. Besuchen Sie',
    body_70_link_text:'www.FreeStyleCheck.com',
    body_70_end: ', um zu prüfen, ob Ihr aktueller oder unbenutzter Sensor potenziell betroffen ist. Wenn Ihre Sensorwerte nicht mit Ihren Symptomen oder Erwartungen übereinstimmen, schalten Sie den Auto-Modus aus und verwenden Sie ein Blutzuckermessgerät, um Therapieentscheidungen zu treffen. Wenn Sie Fragen haben oder Probleme mit Ihrem FreeStyle Libre 3 System-Sensor melden müssen, wenden Sie sich an den Abbott-Kundendienst unter 0800 93 00 93. Die Seriennummer Ihres aktuellen Sensors finden Sie im App-Menü im Abschnitt „Sensor“.',
    body_70_link:'https://www.FreeStyleCheck.com',
	
    header_69:'iOS App-Update (nur YpsoPump) 25.11.2025',
    body_69:'Lieber mylife CamAPS FX Benutzer, eine NEUE VERSION der Anwendung wird in den nächsten Tagen verfügbar sein. DEAKTIVIEREN Sie die automatischen CAMAPS FX-Updates im App Store, um Ihre bevorzugte Aktualisierungszeit auszuwählen. Ihre derzeitige Version wird am 9. Dezember 2025 EINGESTELLT. Bei Fragen wenden Sie sich bitte an den Ypsomed-Kundenservice.',
	
    header_68:'',
    body_68:'',
	
    header_67:'',
    body_67:'',
	
    header_66:'',
    body_66:'',
    body_66_link_text:'',
    body_66_end: '',
    body_66_link:'',

    header_65:'',
    body_65:'',
    body_65_link_text:'',
    body_65_end: '',
    body_65_link:'',

    header_64:'',
    body_64:'',
    body_64_link_text:'',
    body_64_end: '',
    body_64_link:'',

    header_63:'',
    body_63:'',
    body_63_link_text:'',
    body_63_end: '',
    body_63_link:'',
	
    header_62:'SICHERHEITSHINWEIS IM FELD 28/10/2025',
    body_62:'Zum Lesen gehen Sie bitte zum App-Menü -> Sicherheitsbenachrichtigungen und öffnen Sie den Link zur Sicherheitsbenachrichtigung',
    body_62_link_text:'N-0125',
    body_62_end: '.',
    body_62_link:'https://s3.eu-west-1.amazonaws.com/camaps.safety.notices/Field+Safety+Notice+ET8374+Mylife+Users+DE+final.pdf',

    header_61:'iOS-App-Update (nur YpsoPump) 02.10.2025',
    body_61:'Für optimale App-Leistung aktualisieren Sie bitte Ihre mylife CamAPS FX auf die NEUESTE VERSION (1.4(192)) über den Apple App Store.',

    header_60:'',
    body_60:'',

    header_59:'iOS-App-Update (nur YpsoPump) 22/09/2025',
    body_59:'Lieber mylife CamAPS FX-Nutzer, eine NEUE VERSION der Anwendung wird in den nächsten Tagen verfügbar sein. DEAKTIVIEREN Sie die AUTOMATISCHEN UPDATE von CamAPS FX im App Store, um Ihre bevorzugte Update-Zeit auszuwählen. Eine neue Version des Benutzerhandbuchs wird verfügbar sein. Bei Fragen wenden Sie sich bitte an den Ypsomed-Kundendienst.',

    header_58:'iOS 26 Veröffentlichung (nur YpsoPump) 13/09/2025',
    body_58:'Apple wird bald iOS 26 veröffentlichen. Um eine unterbrechungsfreie Nutzung der mylife CamAPS FX Anwendung zu gewährleisten, überprüfen Sie bitte die Website des Sensormanufacturers, um die Kompatibilität von Smartphone und Betriebssystem vor der Aktualisierung Ihres iPhones auf iOS 26 zu bestätigen. Hinweis: Automatische Updates könnten in den Einstellungen Ihres Telefons standardmäßig aktiviert sein, bitte deaktivieren Sie diese.',

    header_57:'Android-App-Update (YpsoPump nur) 26/08/2025',
    body_57:'Lieber mylife CamAPS FX-Nutzer, eine neue Version der Anwendung wird in den nächsten 2 bis 3 Tagen verfügbar sein. Bitte wählen Sie Ihre bevorzugte Update-Zeit, indem Sie das automatische Update für CamAPS FX im Google Play Store deaktivieren. Eine neue Version des Benutzerhandbuchs wird verfügbar sein. Wenn Sie Fragen haben, kontaktieren Sie bitte den Kundendienst von Ypsomed.',

    header_56:'',
    body_56:'',

    header_55:'',
    body_55:'',

    header_54:'',
    body_54:'',

    header_53:'',
    body_53:'',
	
    header_52:'',
    body_52:'',
	
    header_51:'',
    body_51:'',

    header_50:'',
    body_50:'',

    header_49:'Einstellung der alten App-Versionen 01/07/2025',
    body_49:'Bitte aktualisieren Sie Ihre App auf die neueste Version, die im Google Play Store verfügbar ist. Die aktuelle Version wird ab dem 1. August 2025 nicht mehr funktionieren.',

    header_48:'OS 10 & 11 25/06/2025',
    body_48:'Aus Gründen der Cybersicherheit wird ab dem 1. August 2025 mylife CamAPS FX nur noch auf sensor-kompatiblen Handys mit Android-Betriebssystemen 12 und höher unterstützt. Benutzer von Betriebssystemen unter OS 12 werden mylife CamAPS FX nach diesem Datum nicht mehr aktualisieren oder neu installieren können.',

    header_47:'',
    body_47:'',

    header_46:'iOS Aktualisierung 09/06/2025',
    body_46:'Eine neue App-Version wird in den nächsten Tagen verfügbar sein. Um den gewünschten Update-Zeitpunkt zu wählen, deaktivieren Sie bitte die automatischen App-Updates. Wenn Sie Fragen haben, wenden Sie sich bitte an den Ypsomed-Kundenservice.',

    header_45:'Android OS 16 09/06/2025',
    body_45:'Überprüfen Sie bitte die Kompatibilität Ihres Smartphones und Betriebssystems auf der Website des Sensor-Herstellers, bevor Sie auf Android OS 16 updaten, um eine ununterbrochene Nutzung von CamAPS FX sicherzustellen. Hinweis: Automatische Updates sind möglicherweise standardmäßig in den Einstellungen Ihres Telefons aktiviert.',

    header_44:'iOS-Version (nur YpsoPump) 20/05/2025',
    body_44:'Die mylife CamAPS FX App ist jetzt auch für iPhones verfügbar! Wenn Sie überlegen, auf iOS umzusteigen, besuchen Sie den Abschnitt „Wichtige Informationen für iOS-Nutzer“ auf https://www.mylife-diabetescare.com/de-DE/mylife-loop.html. Eine aktualisierte Version des Benutzerhandbuchs ist verfügbar.',

    header_43:'',
    body_43:'',

    header_42:'',
    body_42:'',
	
    header_41:'',
    body_41:'',

    header_40:'Neues Update (18/03/2025)',
    body_40:'Lieber mylife CamAPS FX Nutzer, eine neue App-Version wird in den nächsten 24 Stunden verfügbar sein. Um Ihren bevorzugten Update-Zeitpunkt zu wählen, deaktivieren Sie die automatische Aktualisierung für CamAPS FX im Google Play Store. Bei Fragen wenden Sie sich bitte an den Kundenservice von Ypsomed.',

    header_39:'',
    body_39:'',

    header_38:'Einstellung der alten App-Version (nur Dana-Pumpe)',
    body_38:'Die aktuelle Version wird am 7. Februar 2025 eingestellt. Bitte aktualisieren Sie Ihre App auf die neueste Version, die auf Amazon Appstore App verfügbar ist.',

    header_37:'Einstellung der alten App-Version (nur Ypsopump)',
    body_37:'Die aktuelle Version wird am 7. Februar 2025 eingestellt. Bitte aktualisieren Sie Ihre App auf die neueste Version, die auf Google Play verfügbar ist.',

    header_36:'Neue App-Version 06/01/2025',
    body_36:'Lieber mylife CamAPS FX Nutzer, eine neue App-Version wird in den nächsten 48 Stunden verfügbar sein. Um Ihren bevorzugten Update-Zeitpunkt zu wählen, deaktivieren Sie die automatische Aktualisierung für CamAPS FX im Google Play Store. Bei Fragen wenden Sie sich bitte an den Kundenservice von Ypsomed.',
		
	header_35:'OS 8 & 9 29/12/2024',
    body_35:'Aus Gründen der Cybersicherheit wird ab dem 1. Januar 2025 CamAPS FX nur noch auf sensor-kompatiblen Handys mit Android-Betriebssystemen 10 und höher unterstützt. Benutzer von Betriebssystemen unter OS 10 werden CamAPS FX nach diesem Datum nicht mehr aktualisieren oder neu installieren können. Erinnerung, das System ist noch nicht OS15-kompatibe',
	
	header_34:'',
    body_34:'',
	
	header_33:'Hinweis zur geplanten Wartung 05/12/2024',
    body_33:'Aufgrund geplanter Wartungsarbeiten an der CamAPS FX Service-Cloud wird die Companion-Funktion am 7. Dezember voraussichtlich ab 11:00 Uhr für etwa drei Stunden nicht verfügbar sein. Wir entschuldigen uns für etwaige Unannehmlichkeiten, die dadurch entstehen könnten..',
	
	header_32:'Aktualisierung des Benutzerhandbuchs 28/11/2024',
    body_32:'Eine aktualisierte Version des Benutzerhandbuchs ist verfügbar.',
	
	header_31:'Neue App-Version 17/11/2024',
    body_31:'Lieber mylife CamAPS FX Nutzer, eine neue App-Version wird in den nächsten 48 Stunden verfügbar sein. Um Ihren bevorzugten Update-Zeitpunkt zu wählen, deaktivieren Sie die automatische Aktualisierung für CamAPS FX im Google Play Store. Bei Fragen wenden Sie sich bitte an den Kundenservice von Ypsomed.',
	
	header_30:'OS 8 & 9 11/10/2024',
    body_30:'Aus Gründen der Cybersicherheit wird ab dem 1. Januar 2025 CamAPS FX nur noch auf sensor-kompatiblen Handys mit Android-Betriebssystemen 10 und höher unterstützt. Benutzer von Betriebssystemen unter OS 10 werden CamAPS FX nach diesem Datum nicht mehr aktualisieren oder neu installieren können.',
	
	header_29:'Neue App-Version 09/10/2024',
    body_29:'Lieber mylife CamAPS FX Nutzer, eine neue App-Version wird in den nächsten 48 Stunden verfügbar sein. Um Ihren bevorzugten Update-Zeitpunkt zu wählen, deaktivieren Sie die automatische Aktualisierung für CamAPS FX im Google Play Store. Bei Fragen wenden Sie sich bitte an den Kundenservice von Ypsomed.',
	
	header_28:'OS 8 & 9 08/07/2024',
    body_28:'Aus Gründen der Cybersicherheit wird ab dem 1. Januar 2025 CamAPS FX nur noch auf sensor-kompatiblen Handys mit Android-Betriebssystemen 10 und höher unterstützt. Benutzer von Betriebssystemen unter OS 10 werden CamAPS FX nach diesem Datum nicht mehr aktualisieren oder neu installieren können.',
	
	header_27:'',
    body_27:'',
	
	header_26:'Aktualisierung des Benutzerhandbuchs 11/05/2024',
    body_26:'Eine aktualisierte Version des Benutzerhandbuchs ist verfügbar.',
	
	header_25:'Neue App-Version 05/05/2024',
    body_25:'Lieber mylife CamAPS FX Nutzer, eine neue App-Version wird in den nächsten 24 Stunden verfügbar sein. Um Ihren bevorzugten Update-Zeitpunkt zu wählen, deaktivieren Sie die automatische Aktualisierung für CamAPS FX im Google Play Store. Bei Fragen wenden Sie sich bitte an den Kundenservice von Ypsomed.',
	
	header_24:'',
    body_24:'',
	
	header_23:'Neue App-Version 24/04/2024',
    body_23:'Lieber mylife CamAPS FX Nutzer, eine neue App-Version wird in den nächsten 24 Stunden verfügbar sein. Um Ihren bevorzugten Update-Zeitpunkt zu wählen, deaktivieren Sie die automatische Aktualisierung für CamAPS FX im Google Play Store. Bei Fragen wenden Sie sich bitte an den Kundenservice von Ypsomed.',
	
	header_22:'Aktualisierung des Benutzerhandbuchs 21/04/2024',
    body_22:'Eine aktualisierte Version des Benutzerhandbuchs ist verfügbar.',
	
	header_21:'',
    body_21:'',
	
	header_20:'',
    body_20:'',

	header_19:'',
    body_19:'',

    header_18:'',
    body_18:'',
	 
    header_17:'',
    body_17:'',

    header_16:'Aktualisierung des Benutzerhandbuchs 04/03/2024',
    body_16:'Eine aktualisierte Version des Benutzerhandbuchs ist verfügbar.',
	
	header_15:'Aktualisierung des Benutzerhandbuchs 04/01/2024',
    body_15:'Eine aktualisierte Version des Benutzerhandbuchs ist verfügbar.',
	
	header_14:'Android OS 14 22/11/2023',
    body_14:'Erinnerung: Überprüfen Sie bitte die Kompatibilität Ihres Smartphones und Betriebssystems auf der Website des Sensor-Herstellers, bevor Sie auf Android OS 14 updaten, um eine ununterbrochene Nutzung von mylife CamAPS FX sicherzustellen. Hinweis: Automatische Updates sind möglicherweise standardmäßig in den Einstellungen Ihres Telefons aktiviert.',
	
	header_13:'SICHERHEITSHINWEIS IM FELD 14/11/2023',
    body_13:'',
    body_13_link_text:'SICHERHEITSHINWEIS IM FELD',
    body_13_end: '. Zum Lesen gehen Sie bitte zum App-Menü -> Sicherheitsbenachrichtigungen und öffnen Sie den Link zur Sicherheitsbenachrichtigung.',
    body_13_link:'https://s3.eu-west-1.amazonaws.com/camaps.safety.notices/Field+Safety+Notice+ET5604+Mylife+Users+-+DE.pdf',

	header_12:'Aktualisierung des Benutzerhandbuchs 10/11/2023',
    body_12:'Eine aktualisierte Version des Benutzerhandbuchs ist verfügbar.',
	
	header_11:'Android OS 14 12/09/2023',
    body_11:'Überprüfen Sie bitte die Kompatibilität Ihres Smartphones und Betriebssystems auf der Website des Sensor-Herstellers, bevor Sie auf Android OS 14 updaten, um eine ununterbrochene Nutzung von mylife CamAPS FX sicherzustellen. Hinweis: Automatische Updates sind möglicherweise standardmäßig in den Einstellungen Ihres Telefons aktiviert. Bitte stellen Sie sicher, dass Sie die mylife CamAPS FX App Version 1.4(173) verwenden, bevor Sie auf Android OS 14 aktualisieren.',
	
	header_10:'SICHERHEITSHINWEIS IM FELD 15/08/2023',
    body_10:'SICHERHEITSHINWEIS IM FELD. Zum Lesen gehen Sie bitte zum App-Menü -> Sicherheitsbenachrichtigungen und öffnen Sie den Link zur Sicherheitsbenachrichtigung.',
	
	header_9:'Aktualisierung des Benutzerhandbuchs 27/07/2023',
    body_9:'Eine aktualisierte Version des Benutzerhandbuchs ist verfügbar.',
	
	header_8:'Kompatibilität mit Glooko 21/07/2023',
    body_8:'Wie bereits angekündigt, wird diasend am 28. Juli eingestellt. Wenn Sie Ihre Daten weiterhin mit Ihrem Diabetesteam teilen möchten, aktualisieren Sie bitte Ihr diasend-Konto auf Glooko oder erstellen Sie ein neues Glooko-Konto. Bitte aktualisieren Sie auf die neueste mylife CamAPS FX-Version, geben Sie Ihren neuen Glooko-Benutzernamen und Ihr Passwort im Share-Menü ein und starten Sie Ihr Smartphone neu. Diasend bleibt für den Rest des Jahres für die Anzeige historischer Daten verfügbar.',
	
	header_7:'Samsung A-Serie 14/07/2023',
    body_7:'Benutzer von Samsung A-Serie Modellen (z.B. A53, A33) könnten nach dem neuesten Samsung One UI 5.1 Update Signalverluste zu ihrem CGM-Sensor festgestellt haben. Samsung hat das Problem identifiziert und arbeitet an einer Lösung. Samsung plant, am 24. Juli (abhängig von Ihrer Region) ein Update für One UI zu veröffentlichen, das das Problem beheben wird. Es wird empfohlen, das Update so bald wie möglich zu installieren, sobald es verfügbar ist. Sollten Sie das Update auf One UI 5.1 noch nicht gemacht haben empfiehlt sich auf das nächste Samsung One UI Update zu warten.',

    header_6:'',
    body_6:'',

    header_5:'Kompatibilität mit Glooko 21/06/2023',
    body_5:'CamAPS FX ist kompatibel mit Glooko. Bitte aktualisieren Sie Ihre CamAPS FX App auf 1.4(172). Wenn Sie Daten mit einer Klinik teilen, werden Sie in Ihrem bestehenden diasend-Konto benachrichtigt, wenn Ihre Klinik ein Upgrade auf Glooko durchführt. Sobald das Upgrade abgeschlossen ist, geben Sie Ihren neuen Glooko-Benutzernamen und Ihr Passwort in das Freigabemenü ein und starten Sie Ihr Smartphone neu. Bitte führen Sie das Upgrade auf Glooko vor dem 28. Juli 2023 durch. Diasend wird für den Rest des Jahres verfügbar sein, um historische Daten einzusehen.',

    header_4:'Aktualisierung des Benutzerhandbuchs 27/05/2023',
    body_4:'Eine aktualisierte Version des Benutzerhandbuchs ist verfügbar.',

    header_3:'SMS-Warnungen (Nur Ypsopumpe) 11/05/2023',
    body_3:'Mit dem bevorstehenden Update 1.4(171) Mitte Mai werden Sie bis zu 5 SMS-Follower aktivieren UND gleichzeitig den Companion-Modus verwenden können. Um den Companion-Modus zu nutzen und Daten teilen zu können, muss das Telefon des Benutzers eine Internetverbindung haben. Benutzer müssen eine SIM-Karte haben, um das Senden von SMS von ihrem Telefon zu ermöglichen. Wenn Sie eine dieser Optionen verwenden, empfehlen wir Ihnen, Ihren Mobilfunktarif zu überprüfen, ob SMS und/oder mobile Daten je nach verwendeter Option enthalten sind.',

    header_2:'Cyber-Sicherheits-Update (Nur Ypsopumpe) 24/04/2023',
    body_2:'Hinweis: Für Nutzer aus Österreich nicht zutreffend. Die Sicherheit der mylife CamAPS FX App hat höchste Priorität. Ab Mitte Mai wird ein von Google Play Store durchgesetztes Cyber-Sicherheits-Update durchgeführt. Nach diesem Update könnte bei einem geringen Anteil der genutzten Smartphones der Cyber-Sicherheitstest nicht bestanden werden. Sie können Ihr Telefon im Voraus testen, indem Sie in der App das Hilfe-Menü aufrufen und die „Integritätsprüfung“ durchführen. Wenn Ihr Telefon bei diesem Test durchfällt  Versuchen, die App zu deinstallieren und neu zu installieren.',

    header_1:'Kompatibilität mit Glooko 14/04/2023',
    body_1:'mylife CamAPS FX ist jetzt kompatibel mit Glooko. Bitte aktualisieren Sie Ihre mylife CamAPS FX-App. Melden Sie sich auf einem Webbrowser bei Ihrem Diasend-Konto an und folgen Sie dem Upgrade-Prozess, da Diasend mit Glooko fusioniert. Nach erfolgreicher Fertigstellung starten Sie bitte Ihr Telefon neu, um Ihre Daten automatisch an Glooko zu senden. Diasend wird für den Rest des Jahres verfügbar sein, um bisherige Daten einzusehen. Bitte aktualisieren Sie vor dem 14. Juni 2023 auf Glooko, wenn Sie Diasend nutzen. Hinweis: Wenn Sie während des Upgrade-Vorgangs Ihr Passwort ändern, müssen Sie das Passwort auch in mylife CamAPS FX im Menü „Teilen“ aktualisieren.',
};
